// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__30jsy","productName":"Table_productName__3OJFv"};